import { routes } from "@/routes/routes";

// Nothing to answer while the proof of income is reviewed: the review screen
// opens straight away.
export const getProofOfIncomeScreen = (): string => routes.offer.proofOfIncome;
